

























import { PreApprovedSolutionModalVue } from "@/extensions/app/PreApprovedSolutionModalVue";
import { Component } from "vue-property-decorator";
import VerifyBox from "@/components/app/VerifyBox.vue";

@Component({
  components: { VerifyBox }
})
export default class PreApprovedSolutionModal extends PreApprovedSolutionModalVue {

  async onCancelLinkClick() {
    await this.init();
    await this.destroyForm();
    this.$emit('slideClose', this.props);
  }
}
